/**
 * Created by rak on 11/27/2017.
 */
'use strict';
angular.module('betosyswebapp').service('customerService', function (AdmFramworkService, $translate, customerName, crudService) {

  /**
   * build system sets the customer name while building , set the customer you need to defaultCustomer variable under build js .
   * @type {string}
   */
  // var customerName = 'fbr';
  var customerSideBar = {
    'fbr': [
      AdmFramworkService.createMenuItem('sidebar.betotrack.dashboard', 'betotrack.dashboard', '', 'fa fa-map-marker'),
      AdmFramworkService.createParentMenuItem('sidebar.betotrack.driver',
        [
          AdmFramworkService.createChildMenuItem('sidebar.betotrack.driverDashbordMenu', 'driverdashboard', ''),
          AdmFramworkService.createChildMenuItem('sidebar.betotrack.tachoHistoryDashboardMenu', 'tachohistorydashboard', '')

        ], 'fa fa-clock-o'),

      /* AdmFramworkService.createMenuItem('sidebar.betotrack.portalcommand', 'portalcommand', '', 'fa fa-pencil-square-o'),*/
      AdmFramworkService.createMenuItem('sidebar.betotrack.fms', 'fmsdashboard', '', 'fa fa-tachometer'),
      AdmFramworkService.createParentMenuItem('sidebar.betotrack.tachoDashboardMenu',
        [
          AdmFramworkService.createChildMenuItem('sidebar.betotrack.tachoDownloadStatusDashboardMenu', 'tachodownloaddashboard', '', 'fa fa-download')], 'digital-tachograph'),
      AdmFramworkService.createMenuItem('sidebar.betotrack.map', 'trackMap', '', 'fa fa-globe'),
      AdmFramworkService.createParentMenuItem('sidebar.betotrack.reports',
        [
          AdmFramworkService.createChildMenuItem('sidebar.betotrack.reportitems.vehicledetail', 'reports.vehicleDetail', ''),
          /* AdmFramworkService.createChildMenuItem('sidebar.betotrack.reportitems.groupdetail', 'reports.groupDetail', ''), */ // disabled based on feed back by @ds :  BetoTrack / Reporting :  9/8/2018 3:23 PM,
          AdmFramworkService.createChildMenuItem('sidebar.betotrack.reportitems.groupsummary', 'reports.groupSummary', ''),
          AdmFramworkService.createChildMenuItem('sidebar.betotrack.reportitems.performance', 'reports.performance', '')

        ], 'fa fa-list-alt'),

      AdmFramworkService.createParentMenuItem('sidebar.betotrack.admin',
        [
          AdmFramworkService.createChildMenuItem('sidebar.betotrack.adminitems.contactmgmt', 'contacts.list', ''),
          AdmFramworkService.createChildMenuItem('sidebar.betotrack.adminitems.bookmgmt', 'books.list', ''),

        ], 'fa fa-cog'),
      // AdmFramworkService.createMenuItem('sidebar.betotrack.telephone', 'telephones.list', '', 'fa fa-phone'),
      AdmFramworkService.createLogoItem()
    ],
    'lgs': [
      AdmFramworkService.createMenuItem('sidebar.betotrack.dashboard', 'betotrack.dashboard', '', 'fa fa-map-marker'),
      AdmFramworkService.createParentMenuItem('sidebar.betotrack.driver',
        [
          AdmFramworkService.createChildMenuItem('sidebar.betotrack.driver', 'driverdashboard', ''),
          AdmFramworkService.createChildMenuItem('sidebar.betotrack.tachoHistoryDashboardMenu', 'tachohistorydashboard', '')

        ], 'fa fa-clock-o'),

      AdmFramworkService.createMenuItem('sidebar.betotrack.map', 'trackMap', '', 'fa fa-globe'),
      AdmFramworkService.createParentMenuItem('sidebar.betotrack.reports',
        [
          AdmFramworkService.createChildMenuItem('sidebar.betotrack.reportitems.vehicledetail', 'reports.vehicleDetail', ''),
          /*AdmFramworkService.createChildMenuItem('sidebar.betotrack.reportitems.groupdetail', 'reports.groupDetail', ''), */ // disabled based on feed back by @ds :  BetoTrack / Reporting :  9/8/2018
          AdmFramworkService.createChildMenuItem('sidebar.betotrack.reportitems.groupsummary', 'reports.groupSummary', ''),
          AdmFramworkService.createChildMenuItem('sidebar.betotrack.reportitems.performance', 'reports.performance', '')

        ], 'fa fa-list-alt'),

      AdmFramworkService.createParentMenuItem('sidebar.betotrack.admin',
        [
          AdmFramworkService.createChildMenuItem('sidebar.betotrack.adminitems.contactmgmt', 'contacts.list', ''),
          AdmFramworkService.createChildMenuItem('sidebar.betotrack.adminitems.bookmgmt', 'books.list', ''),

        ], 'fa fa-cog'),
      // AdmFramworkService.createMenuItem('sidebar.betotrack.telephone', 'telephones.list', '', 'fa fa-phone'),
      AdmFramworkService.createLogoItem()
    ]

  };

  var customerDashbord = {
    'fbr': {
      lastLocationDashboard: {
        XS: {
          title: $translate.instant('dashBoard.lastLocationDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'vehicleListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleListTitle'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 4
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'fleetMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'config': {
                  'mapURL': null,
                  'height': 600
                },
                'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

              }, {
                'type': 'TempMonitoringWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.title'),
                'config': {
                  'height': 450,
                  'maxHours': 2,
                  'temperatureUnit': '',
                  'max': null,
                  'min': null
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.lastLocationDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'vehicleListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleListTitle'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 5
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 5
                }
              }, {
                'type': 'fleetMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'config': {
                  'mapURL': null,
                  'height': 600
                },
                'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

              }, {
                'type': 'TempMonitoringWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.title'),
                'config': {
                  'height': 450,
                  'maxHours': 2,
                  'temperatureUnit': '',
                  'max': null,
                  'min': null
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.lastLocationDashboardTitle'),
          structure: '9-6 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'vehicleListWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleListTitle'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 8
                    }
                  }, {
                    'type': 'fleetMapWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'config': {
                      'mapURL': null,
                      'height': 600
                    },
                    'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

                  }, {
                    'type': 'TempMonitoringWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.title'),
                    'config': {
                      'height': 450,
                      'maxHours': 2,
                      'temperatureUnit': '',
                      'max': null,
                      'min': null
                    }
                  }]
                }]
              }]
            },
            {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 8
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.lastLocationDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'vehicleListWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleListTitle'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 10
                    }
                  }, {
                    'type': 'fleetMapWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'config': {
                      'mapURL': null,
                      'height': 600
                    },
                    'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

                  }, {
                    'type': 'TempMonitoringWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.title'),
                    'config': {
                      'height': 450,
                      'maxHours': 2,
                      'temperatureUnit': '',
                      'max': null,
                      'min': null
                    }
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }
      },
      driverDashboard: {
        XS: {
          title: $translate.instant('dashBoard.driverDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'DriverWrkHrsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 4
                }
              }, {
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'DriverDigitalTachoStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                'config': {

                }
              }]
            }, {
              columns: [{
                styleClass: 'col-md-6'
              }, {
                styleClass: 'col-md-6'
              }]
            }]
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.driverDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'DriverWrkHrsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 5
                }
              }, {
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'DriverDigitalTachoStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                'config': {}
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'fleetMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'config': {
                  'mapURL': null,
                  'height': 600
                },
                'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

              }]
            }, {
              columns: [{
                styleClass: 'col-md-6'
              }, {
                styleClass: 'col-md-6'
              }]
            }]
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.driverDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'DriverWrkHrsWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 8
                    }
                  },
                  {
                    'type': 'fleetMapWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'config': {
                      'mapURL': null,
                      'height': 600
                    },
                    'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

                  }]
                }]
              }]
            }, {
              'type': 'DriverWrkHrsSVGWidget',
              'fullScreen': true,
              'modalSize': 'lg',
              'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
              'config': {
                'mapURL': null,
                'height': 450
              }
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              },
              {
                'type': 'DriverDigitalTachoStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                'config': {}
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.driverDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'DriverWrkHrsWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 10
                    }
                  },
                  {
                    'type': 'fleetMapWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'config': {
                      'mapURL': null,
                      'height': 600
                    },
                    'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              },
              {
                'type': 'DriverDigitalTachoStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                'config': {}
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }
      },
      portalCommandsDashboard: {
        XS: {
          title: $translate.instant('dashBoard.portalCommandsDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'vehiclesListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': 4
                }
              },
              {
                'type': 'vehicleStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleStatusWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': ''
                }
              }, /*{ // disabled due to FBR Testing.
                 'type': 'digitalOutputsWidget',
                 'fullScreen': true,
                 'modalSize': 'lg',
                 'title': $translate.instant('dashBoard.fleetManagement.digitalOutputsWidget.title'),
                 'config': {
                 'statusCodeList': [],
                 'vehicleList': [],
                 'vehicleGroup': null,
                 'vehicleGroupList': [],
                 'statusCode': null,
                 'noOfGridRows': ''
                 }
                 }, */{
                'type': 'pendingCommandsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': '',
                  'height': 300
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.portalCommandsDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'vehiclesListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': 5
                }
              },
              {
                'type': 'vehicleStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleStatusWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': ''
                }
              }, /*{ // disabled due to FBR Testing.
                 'type': 'digitalOutputsWidget',
                 'fullScreen': true,
                 'modalSize': 'lg',
                 'title': $translate.instant('dashBoard.fleetManagement.digitalOutputsWidget.title'),
                 'config': {
                 'statusCodeList': [],
                 'vehicleList': [],
                 'vehicleGroup': null,
                 'vehicleGroupList': [],
                 'statusCode': null,
                 'noOfGridRows': ''
                 }
                 }, */{
                'type': 'pendingCommandsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': '',
                  'height': 300
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.portalCommandsDashboardTitle'),
          structure: '7-5 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-7',
              'widgets': [{
                'type': 'vehiclesListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': 8
                }
              }]
            }, {
              'styleClass': 'col-md-5',
              'widgets': [{
                'type': 'vehicleStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleStatusWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': ''
                }
              }, /*{// disabled due to FBR Testing.
               'type': 'digitalOutputsWidget',
               'fullScreen': true,
               'modalSize': 'lg',
               'title': $translate.instant('dashBoard.fleetManagement.digitalOutputsWidget.title'),
               'config': {
               'statusCodeList': [],
               'vehicleList': [],
               'vehicleGroup': null,
               'vehicleGroupList': [],
               'statusCode': null,
               'noOfGridRows': ''
               }
               },*/ {
                'type': 'pendingCommandsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': '',
                  'height': 300
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.portalCommandsDashboardTitle'),
          structure: '7-5 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-7',
              'widgets': [{
                'type': 'vehiclesListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': 10
                }
              }]
            }, {
              'styleClass': 'col-md-5',
              'widgets': [{
                'type': 'vehicleStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleStatusWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': ''
                }
              }, /*{// disabled due to FBR Testing.
               'type': 'digitalOutputsWidget',
               'fullScreen': true,
               'modalSize': 'lg',
               'title': $translate.instant('dashBoard.fleetManagement.digitalOutputsWidget.title'),
               'config': {
               'statusCodeList': [],
               'vehicleList': [],
               'vehicleGroup': null,
               'vehicleGroupList': [],
               'statusCode': null,
               'noOfGridRows': ''
               }
               },*/ {
                'type': 'pendingCommandsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': '',
                  'height': 300
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }
      },
      fmsDashboard: {
        XS: {
          title: $translate.instant('dashBoard.fmsDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'FMSVehicleWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 4
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 8
                }
              }]
            }, {
              columns: [{
                styleClass: 'col-md-6'
              }, {
                styleClass: 'col-md-6'
              }]
            }]
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.fmsDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'FMSVehicleWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 5
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              columns: [{
                styleClass: 'col-md-6'
              }, {
                styleClass: 'col-md-6'
              }]
            }]
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.fmsDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'styleClass': 'col-md-9',
            'rows': [{
              'columns': [{
                'styleClass': 'col-md-12',
                'widgets': [{
                  'type': 'FMSVehicleWidget',
                  'fullScreen': true,
                  'modalSize': 'lg',
                  'title': $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList'),
                  'config': {
                    'vehicleGroup': null,
                    'noOfGridRows': 20
                  }
                }]
              }]
            }]
          }, {
            'columns': [{
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.fmsDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'FMSVehicleWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 20
                    }
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }
      },
      tachoHistoryDashboard: {
        XS: {
          title: $translate.instant('dashBoard.tachoHistoryDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoHistoryWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle'),
                    'config': {
                      'noOfGridRows': 8
                    }
                  }]
                }]
              }, {
                'columns': [{
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'tachoEventDetailWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'),
                    'config': {}
                  }]
                }, {
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'DriverDigitalTachoStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                    'config': {}
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 395
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.tachoHistoryDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoHistoryWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle'),
                    'config': {
                      'noOfGridRows': 8
                    }
                  }]
                }]
              }, {
                'columns': [{
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'tachoEventDetailWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'),
                    'config': {}
                  }]
                }, {
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'DriverDigitalTachoStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                    'config': {}
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 395
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, {
                'styleClass': 'col-md-6', 'widgets': []
              }]
            }], 'widgets': []
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.tachoHistoryDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoHistoryWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle'),
                    'config': {
                      'noOfGridRows': 8
                    }
                  }]
                }]
              }, {
                'columns': [{
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'tachoEventDetailWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'),
                    'config': {}
                  }]
                }, {
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'DriverDigitalTachoStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                    'config': {}
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 395
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, {
                'styleClass': 'col-md-6', 'widgets': []
              }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.tachoHistoryDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [
              {
                'styleClass': 'col-md-9',
                'rows': [{
                  'columns': [{
                    'styleClass': 'col-md-12',
                    'widgets': [{
                      'type': 'tachoHistoryWidget',
                      'fullScreen': true,
                      'modalSize': 'lg',
                      'title': $translate.instant('dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle'),
                      'config': {
                        'noOfGridRows': 8
                      }
                    }]
                  }]
                }, {
                  'columns': [{
                    'styleClass': 'col-md-6',
                    'widgets': [{
                      'type': 'tachoEventDetailWidget',
                      'fullScreen': true,
                      'modalSize': 'lg',
                      'title': $translate.instant('dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'),
                      'config': {}
                    }]
                  }, {
                    'styleClass': 'col-md-6',
                    'widgets': [{
                      'type': 'DriverDigitalTachoStatusWidget',
                      'fullScreen': true,
                      'modalSize': 'lg',
                      'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                      'config': {}
                    }]
                  }]
                }]
              }, {
                'styleClass': 'col-md-3',
                'widgets': [{
                  'type': 'DriverWrkHrsSVGWidget',
                  'fullScreen': true,
                  'modalSize': 'lg',
                  'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                  'config': {
                    'mapURL': null,
                    'height': 450
                  }
                }, {
                  'type': 'vehicleMapWidget',
                  'fullScreen': true,
                  'modalSize': 'lg',
                  'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                  'config': {
                    'mapURL': null,
                    'height': 395
                  }
                }]
              }, {
                'columns': [{
                  'styleClass': 'col-md-6', 'widgets': []
                }, {
                  'styleClass': 'col-md-6', 'widgets': []
                }]
              }], 'widgets': []
          }]
        }
      },
      tachoDownloadStatus: {
        XS: {
          title: $translate.instant('dashBoard.tachoDownloadStatusTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'tachoDownloadStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.tachoDownloadStatus.title'),
                'config': {
                  'noOfGridRows': 20,
                  vehicleGroup: null
                }
              }
            ]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.tachoDownloadStatusTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'tachoDownloadStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.tachoDownloadStatus.title'),
                'config': {
                  'noOfGridRows': 20,
                  vehicleGroup: null
                }
              }
            ]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.tachoDownloadStatusTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoDownloadStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoDownloadStatus.title'),
                    'config': {
                      'noOfGridRows': 20,
                      vehicleGroup: null
                    }
                  }]
                }]
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.tachoDownloadStatusTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoDownloadStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoDownloadStatus.title'),
                    'config': {
                      'noOfGridRows': 20,
                      vehicleGroup: null
                    }
                  }]
                }]
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }

      }

    },
    'lgs': {
      lastLocationDashboard: {
        XS: {
          title: $translate.instant('dashBoard.lastLocationDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'vehicleListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleListTitle'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 4
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 4
                }
              }, {
                'type': 'fleetMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'config': {
                  'mapURL': null,
                  'height': 600
                },
                'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')
              }, {
                'type': 'TempMonitoringWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.title'),
                'config': {
                  'height': 450,
                  'maxHours': 2,
                  'temperatureUnit': '',
                  'max': null,
                  'min': null
                }
              }
              ]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.lastLocationDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'vehicleListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleListTitle'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 5
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 5
                }
              }, {
                'type': 'fleetMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'config': {
                  'mapURL': null,
                  'height': 600
                },
                'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

              },]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.lastLocationDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'styleClass': 'col-md-9',
            'rows': [{
              'columns': [{
                'styleClass': 'col-md-12',
                'widgets': [{
                  'type': 'vehicleListWidget',
                  'fullScreen': true,
                  'modalSize': 'lg',
                  'title': $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleListTitle'),
                  'config': {
                    'vehicleGroup': null,
                    'noOfGridRows': 8
                  }
                }, {
                  'type': 'fleetMapWidget',
                  'fullScreen': true,
                  'modalSize': 'lg',
                  'config': {
                    'mapURL': null,
                    'height': 600
                  },
                  'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

                }, {
                  'type': 'TempMonitoringWidget',
                  'fullScreen': true,
                  'modalSize': 'lg',
                  'title': $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.title'),
                  'config': {
                    'height': 450,
                    'maxHours': 2,
                    'temperatureUnit': '',
                    'max': null,
                    'min': null
                  }
                }]
              }]
            }]
          }, {
            'columns': [{
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.lastLocationDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'vehicleListWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleListTitle'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 10
                    }
                  }, {
                    'type': 'fleetMapWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'config': {
                      'mapURL': null,
                      'height': 600
                    },
                    'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }
      },
      driverDashboard: {
        XS: {
          title: $translate.instant('dashBoard.driverDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'DriverWrkHrsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 4
                }
              }, {
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'DriverDigitalTachoStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                'config': {}
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'fleetMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'config': {
                  'mapURL': null,
                  'height': 600
                },
                'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

              }]
            }, {
              columns: [{
                styleClass: 'col-md-6'
              }, {
                styleClass: 'col-md-6'
              }]
            }]
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.driverDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'DriverWrkHrsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 5
                }
              }, {
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'DriverDigitalTachoStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                'config': {}
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'fleetMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'config': {
                  'mapURL': null,
                  'height': 600
                },
                'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

              }]
            }, {
              columns: [{
                styleClass: 'col-md-6'
              }, {
                styleClass: 'col-md-6'
              }]
            }]
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.driverDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'DriverWrkHrsWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 8
                    }
                  },
                  {
                    'type': 'fleetMapWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'config': {
                      'mapURL': null,
                      'height': 600
                    },
                    'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {

                'type': 'DriverDigitalTachoStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                'config': {}
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.driverDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'DriverWrkHrsWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 10
                    }
                  },
                  {
                    'type': 'fleetMapWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'config': {
                      'mapURL': null,
                      'height': 600
                    },
                    'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              },
              {
                'type': 'DriverDigitalTachoStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                'config': {}
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }
      },
      portalCommandsDashboard: {
        XS: {
          title: $translate.instant('dashBoard.portalCommandsDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'vehiclesListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': 4
                }
              },
              {
                'type': 'vehicleStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleStatusWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': ''
                }
              }, /*{ // disabled due to FBR Testing.
                 'type': 'digitalOutputsWidget',
                 'fullScreen': true,
                 'modalSize': 'lg',
                 'title': $translate.instant('dashBoard.fleetManagement.digitalOutputsWidget.title'),
                 'config': {
                 'statusCodeList': [],
                 'vehicleList': [],
                 'vehicleGroup': null,
                 'vehicleGroupList': [],
                 'statusCode': null,
                 'noOfGridRows': ''
                 }
                 }, */{
                'type': 'pendingCommandsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': '',
                  'height': 300
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.portalCommandsDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'vehiclesListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': 5
                }
              },
              {
                'type': 'vehicleStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleStatusWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': ''
                }
              }, /*{ // disabled due to FBR Testing.
                 'type': 'digitalOutputsWidget',
                 'fullScreen': true,
                 'modalSize': 'lg',
                 'title': $translate.instant('dashBoard.fleetManagement.digitalOutputsWidget.title'),
                 'config': {
                 'statusCodeList': [],
                 'vehicleList': [],
                 'vehicleGroup': null,
                 'vehicleGroupList': [],
                 'statusCode': null,
                 'noOfGridRows': ''
                 }
                 }, */{
                'type': 'pendingCommandsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': '',
                  'height': 300
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.portalCommandsDashboardTitle'),
          structure: '7-5 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-7',
              'widgets': [{
                'type': 'vehiclesListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': 8
                }
              }]
            }, {
              'styleClass': 'col-md-5',
              'widgets': [{
                'type': 'vehicleStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleStatusWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': ''
                }
              }, /*{// disabled due to FBR Testing.
               'type': 'digitalOutputsWidget',
               'fullScreen': true,
               'modalSize': 'lg',
               'title': $translate.instant('dashBoard.fleetManagement.digitalOutputsWidget.title'),
               'config': {
               'statusCodeList': [],
               'vehicleList': [],
               'vehicleGroup': null,
               'vehicleGroupList': [],
               'statusCode': null,
               'noOfGridRows': ''
               }
               },*/ {
                'type': 'pendingCommandsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': '',
                  'height': 300
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.portalCommandsDashboardTitle'),
          structure: '7-5 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-7',
              'widgets': [{
                'type': 'vehiclesListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': 10
                }
              }]
            }, {
              'styleClass': 'col-md-5',
              'widgets': [{
                'type': 'vehicleStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleStatusWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': ''
                }
              }, /*{// disabled due to FBR Testing.
               'type': 'digitalOutputsWidget',
               'fullScreen': true,
               'modalSize': 'lg',
               'title': $translate.instant('dashBoard.fleetManagement.digitalOutputsWidget.title'),
               'config': {
               'statusCodeList': [],
               'vehicleList': [],
               'vehicleGroup': null,
               'vehicleGroupList': [],
               'statusCode': null,
               'noOfGridRows': ''
               }
               },*/ {
                'type': 'pendingCommandsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': '',
                  'height': 300
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }
      },
      fmsDashboard: {
        XS: {
          title: $translate.instant('dashBoard.fmsDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'FMSVehicleWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 4
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              columns: [{
                styleClass: 'col-md-6'
              }, {
                styleClass: 'col-md-6'
              }]
            }]
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.fmsDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'FMSVehicleWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 5
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              columns: [{
                styleClass: 'col-md-6'
              }, {
                styleClass: 'col-md-6'
              }]
            }]
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.fmsDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'FMSVehicleWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 20
                    }
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.fmsDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'FMSVehicleWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 20
                    }
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }
      },
      tachoHistoryDashboard: {
        XS: {
          title: $translate.instant('dashBoard.tachoHistoryDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoHistoryWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle'),
                    'config': {
                      'noOfGridRows': 8
                    }
                  }]
                }]
              }, {
                'columns': [{
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'tachoEventDetailWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'),
                    'config': {}
                  }]
                }, {
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'DriverDigitalTachoStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                    'config': {}
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 395
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.tachoHistoryDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoHistoryWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle'),
                    'config': {
                      'noOfGridRows': 8
                    }
                  }]
                }]
              }, {
                'columns': [{
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'tachoEventDetailWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'),
                    'config': {}
                  }]
                }, {
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'DriverDigitalTachoStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                    'config': {}
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              },{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 395
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, {
                'styleClass': 'col-md-6', 'widgets': []
              }]
            }], 'widgets': []
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.tachoHistoryDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoHistoryWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle'),
                    'config': {
                      'noOfGridRows': 8
                    }
                  }]
                }]
              }, {
                'columns': [{
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'tachoEventDetailWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'),
                    'config': {}
                  }]
                }, {
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'DriverDigitalTachoStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                    'config': {}
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 395
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, {
                'styleClass': 'col-md-6', 'widgets': []
              }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.tachoHistoryDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoHistoryWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle'),
                    'config': {
                      'noOfGridRows': 8
                    }
                  }]
                }]
              }, {
                'columns': [{
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'tachoEventDetailWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'),
                    'config': {}
                  }]
                }, {
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'DriverDigitalTachoStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                    'config': {}
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 395
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, {
                'styleClass': 'col-md-6', 'widgets': []
              }]
            }], 'widgets': []
          }]
        }
      }

    }
  };

  this.getVehicleFailuresCount = function () {
    var requestParam = {
      reportName: 'TellTaleAlertCount'
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('overview', 'vehicleeventdetailcount', param);
  };

  this.getCustomerSideBarMenu = function () {
    return customerSideBar[customerName];
  };
  this.getLoginWindowText = function () {
    return $translate.instant('login.tittle.' + customerName);
  };
  this.getProductLogText = function () {
    return $translate.instant('nav.productLogoText.' + customerName);
  };
  this.getProductLogoShortText = function () {
    return $translate.instant('nav.productLogoShortText.' + customerName);
  };
  this.getLastLocationDashboardConfig = function (viewPortName) {
    return customerDashbord[customerName].lastLocationDashboard[viewPortName];
  };

  this.getDriverDashboardConfig = function (viewPortName) {
    return customerDashbord[customerName].driverDashboard[viewPortName];
  };
  this.getPortalCommandDashboardConfig = function (viewPortName) {
    return customerDashbord[customerName].portalCommandsDashboard[viewPortName];
  };
  this.getFmsDashboardConfig = function (viewPortName) {
    return customerDashbord[customerName].fmsDashboard[viewPortName];
  };

  this.getTachoHistoryDashboardConfig = function (viewPortName) {
    return customerDashbord[customerName].tachoHistoryDashboard[viewPortName];
  };
  this.getTachoDownloadStatusDashboardConfig = function (viewPortName) {
    return customerDashbord[customerName].tachoDownloadStatus[viewPortName];
  };

});



// WEBPACK FOOTER //
// ./.tmp/components/common/services/customerService.js